import { DeactivateJobOffersTranslation } from 'locales/de/pages/Jobmarket/deactivateJobOffers';

const en: DeactivateJobOffersTranslation = {
  title: 'Deactivate job offers',
  steps: {
    jobOfferings: 'Job offers',
    jobPeriods: 'Period',
    verify: 'Verify'
  },
  jobPeriods: {
    activeJobPeriod: 'Active period',
    inactiveJobPeriod: 'Inactive period',
    selectAll: 'Select all periods'
  },
  warning: {
    title: 'Important',
    information: 'The period that has already begun will still be billed.'
  },
  deactivateJobPeriods: {
    success: 'The periods of the job offer were successfully deactivated.',
    failed: 'The periods of the job offer could not be deactivated.'
  },
  button: 'Deactivate',
  tooltip: 'There is currently no period that could be deactivated',
  noJobOfferSelected: 'No joboffer selected',
  noJobPeriodSelected: 'No period selected',
  noPeriodsAvailable: 'No period available to deactivate'
};

export default en;
